import { moduleProviderFactory } from "core/providers";
import { InsuranceCoverageStatusOverviewEmailEdit } from "application/insurance-coverage-status-overview/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
                    {
                        name: "master.app.main.facility-order.overview.edit-email",
                        pattern: "/:facilityOrderId/email",
                        component: InsuranceCoverageStatusOverviewEmailEdit,
                        data: {
                            crumbs: [
                                {
                                    title: "FACILITY_ORDER.CRUMB.TEMPLATES",
                                    route: 'master.app.main.facility-order.facility-order-template.list'
                                },
                                {
                                    title: "INSURANCE_COVERAGE_STATUS_OVERVIEW.TITLE",
                                    route: 'master.app.main.facility-order.overview.edit-email'
                                }
                            ]
                        }
                    },                 
                ]
            }
        ],
        menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB_DAVID",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.list",
						order: 1,
					}  
				]
			},
        ]
    });
})();
